import * as React from 'react';
import { SVGProps } from 'react';

const IconSearchFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.998 20.128a9.997 9.997 0 0 1-5.956 1.956C6.496 22.084 2 17.588 2 12.042 2 6.496 6.496 2 12.042 2c5.546 0 10.042 4.496 10.042 10.042 0 2.23-.726 4.29-1.956 5.956L26 23.87 23.87 26l-5.872-5.872Z"
    />
  </svg>
);
export default IconSearchFilledSizeL;
